const limitaciones = [
  {
    id: "1",
    limitacion: "NO APLICA"
  },
  {
    id: "2",
    limitacion: "BAJA VISIÓN DIAGNOSTICADA"
  },
  {
    id: "3",
    limitacion: "CEGUERA"
  },
  {
    id: "4",
    limitacion: "AUTISMO"
  },
  {
    id: "5",
    limitacion: "MULTIPLE"
  },
  {
    id: "6",
    limitacion: "SORDOS LENGUA DE SEÑAS COLOMBIANA"
  },
  {
    id: "7",
    limitacion: "SORDOS CASTELLANO ORAL"
  },
  {
    id: "8",
    limitacion: "SORDOCEGUERA"
  },
  {
    id: "9",
    limitacion: "LIMITACIÓN FISICA - MOVILIDAD"
  },
  {
    id: "10",
    limitacion: "SORDERA PROFUNDA"
  },
  {
    id: "11",
    limitacion: "HIPOACUSIA O BAJA AUDICIÓN"
  },
  {
    id: "12",
    limitacion: "PARALISIS CEREBRAL"
  },
  {
    id: "13",
    limitacion: "LESIÓN NEUROMUSCULAR"
  },
  {
    id: "14",
    limitacion: "DEFICIENCIA COGNITIVA - RETARDO MENTAL"
  },
  {
    id: "15",
    limitacion: "SÍNDROME DE DOWN"
  },
  {
    id: "16",
    limitacion: "ENANISMO"
  }
]
export default limitaciones